import { useTranslation } from 'react-i18next';
import { SuccessDialog } from '@bliks-io/ui';
import { useCelebrationStore } from '@/stores/celebration-store';

export function RecordingStartedCard() {
  const { t } = useTranslation();
  const recordingStarted = useCelebrationStore((state) => state.recordingStarted);
  const clearRecordingStarted = useCelebrationStore((state) => state.clearRecordingStarted);

  // Unmounts rather than closes: an exit animation would re-render the copy
  // without the cleared process name.
  if (!recordingStarted) return null;

  return (
    <SuccessDialog
      open
      title={t('celebration.recordingStarted.title')}
      description={t('celebration.recordingStarted.description', {
        process: recordingStarted.processName
      })}
      primary={{ label: t('common.Done'), onClick: clearRecordingStarted }}
      onDismiss={clearRecordingStarted}
    />
  );
}
